import { render, staticRenderFns } from "./AddInterface.vue?vue&type=template&id=4caa23fb&scoped=true&"
import script from "./AddInterface.vue?vue&type=script&lang=js&"
export * from "./AddInterface.vue?vue&type=script&lang=js&"
import style0 from "./AddInterface.vue?vue&type=style&index=0&id=4caa23fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4caa23fb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VContainer,VLayout})
